

function validateFullName(fullName) {
  var re = /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/;
  return (fullName && re.test(fullName.toLowerCase()));
}

function validateName(name) {
  var re = /(?=.{4,24}$)^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/
  return (name && re.test(name.toLowerCase()));
}

function validateStructName(structName) {
  var re = /^.{1,24}$/;
  return (structName && re.test(structName));
}

function validateStructAddress(structAddr){
  var re = /^.{1,96}$/; // Alphanumeric only
  return (structAddr && re.test(structAddr)); 
}

function validateEUI(eui) {
  var re = /^(?=.{1,50}$)[^\W_]+(?: [^\W_]+)*$/;
  return (eui && re.test(eui));
}

function validateNameNoSpaceBeginning(name){
  var re = /(?=.{1,24}$)^[a-zA-Z0-9_@.#&+-]+( [a-zA-Z0-9_@.#&+-]+)*$/;
  return (name && re.test(name));

}

function validateHtmlColorName(color) {
  const validColor = [
    "white",
    "silver",
    "gray",
    "black",
    "red",
    "maroon",
    "yellow",
    "olive",
    "lime",
    "green",
    "aqua",
    "teal",
    "blue",
    "navy",
    "fuchsia",
    "purple",
  ];
  return validColor.includes(color);
}

function validateCoordinate(coordinate){
  var re = /^-?[0-9]{1,3}(?:\.[0-9]{1,10})?$/
  return (coordinate && re.test(coordinate));
}

function validateSensorName(name) {
  var re = /^[a-zA-Z0-9 ]{2,16}$/;
  return (name && re.test(name));
}

function validateStructSpans(spans){
  var re = /^[1-9][0-9]*$/
  return (spans && re.test(spans))
}

/* User */
function validateUsername(username){
  var re = /^[a-zA-Z0-9]{3,24}$/;
  return (username && re.test(username));
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (email && re.test(email.toString().toLowerCase()));
}

function validateLoraAppID(loraAppID){
  var re = /^[A-Z0-9]{8}$/;
  return (loraAppID && re.test(loraAppID));
}

function validateGenericAppID(appID){
  var re = /^[^\s@]+$/;
  return (appID && re.test(appID));
}

function validateLoraToken(loraToken){
  var re = /^\S{10,}$/;  // Any 6+ char but space 
  return (loraToken && re.test(loraToken));
}

function validatePassword(psw){
  /*
  Require the string to be 7 - 50 characters long
  Allow the string to be contain A-Z, a-z, 0-9, and !@#$%^&*()_[\]{},.<>+=- characters
  Require at least one character from any three of the following cases:
    English uppercase alphabet characters A–Z
    English lowercase alphabet characters a–z
    Base 10 digits 0–9
    Non-alphanumeric characters !@#$%^&*()_[]{},.<>+=-
  */
  var re = /^(?:(?=.*?[A-Z])(?:(?=.*?[0-9])(?=.*?[-!@#$%^&*()_[\]{},.<>+=])|(?=.*?[a-z])(?:(?=.*?[0-9])|(?=.*?[-!@#$%^&*()_[\]{},.<>+=])))|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-!@#$%^&*()_[\]{},.<>+=]))[A-Za-z0-9!@#$%^&*()_[\]{},.<>+=-]{7,50}$/; 
  return (psw && re.test(psw));
}
module.exports = {
  validateEmail,
  validateFullName,
  validateName,
  validateEUI,
  validateHtmlColorName,
  validateSensorName,
  validateStructName,
  validateStructSpans,
  validateStructAddress,
  validateCoordinate,
  validateUsername,
  validateLoraAppID,
  validateGenericAppID,
  validateLoraToken,
  validatePassword,
  validateNameNoSpaceBeginning
};
